import { Style } from 'es-map-widget';
import proj4 from 'es-map-widget/dist/utils/proj4';
import { useEffect } from 'react';
import { styles } from '../mapwrapper/MapWrapperStyles';

const HUNGARY_BOUNDARY_URL = `${process.env.PUBLIC_URL || ''}/geo/hungary-boundary.geojson`;
const EOV_PROJECTION = 'EPSG:23700';

proj4.defs(
    EOV_PROJECTION,
    '+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs'
);

const transformCoordinate = (coordinate) => proj4('EPSG:4326', EOV_PROJECTION, coordinate);

const transformGeometryCoordinates = (geometryType, coordinates) => {
    switch (geometryType) {
        case 'Point':
            return transformCoordinate(coordinates);
        case 'LineString':
        case 'MultiPoint':
            return coordinates.map(transformCoordinate);
        case 'Polygon':
        case 'MultiLineString':
            return coordinates.map((line) => line.map(transformCoordinate));
        case 'MultiPolygon':
            return coordinates.map((polygon) =>
                polygon.map((line) => line.map(transformCoordinate))
            );
        default:
            return coordinates;
    }
};

const geoJsonToMapElements = (geoJson) => {
    if (!geoJson?.features) {
        return [];
    }

    return geoJson.features
        .filter((feature) => feature.geometry)
        .map((feature) => ({
            ...(feature.properties || {}),
            geom: {
                type: feature.geometry.type,
                coordinates: transformGeometryCoordinates(
                    feature.geometry.type,
                    feature.geometry.coordinates
                ),
            },
            style: new Style(styles.hungaryBoundary),
        }));
};

const HungaryBoundaryDataprovider = ({ setSource }) => {
    useEffect(() => {
        const controller = new AbortController();

        fetch(HUNGARY_BOUNDARY_URL, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to load Hungary boundary: ${response.status}`);
                }
                return response.json();
            })
            .then((geoJson) => {
                setSource(geoJsonToMapElements(geoJson));
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error);
                    setSource(null);
                }
            });

        return () => {
            controller.abort();
        };
    }, [setSource]);

    return null;
};

export default HungaryBoundaryDataprovider;
